import { Link } from "react-router-dom";

export function LargeCard({ img, subtitle, title, description, link }) {
  return (
    <article className="card-big">
      <Link to={link} style={{ margin: "0" }}>
        <img src={img} alt="project thumbnail" />
      </Link>
      <div>
        <h2>{subtitle}</h2>
        <h1>{title}</h1>
        <p>{description}</p>
        <Link className="primary-button" to={link}>
          See Project
        </Link>
      </div>
    </article>
  );
}

export function SmallCard({ img, subtitle, title, link }) {
  return (
    <article className="card-small">
      <Link
        to={link}
        style={{ margin: "0", textDecoration: "none", color: "inherit" }}
      >
        <img src={img} alt="project thumbnail" />
        <h1>{title}</h1>
        <h2>{subtitle}</h2>{" "}
      </Link>
    </article>
  );
}
